module.exports = __webpack_public_path__ + "img/Postmodernisme_Tore-Renberg.cf257152.jpg";